import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AbilityProvider } from '@core/permissions/ability'
import { RequireAuth } from './guards/RequireAuth'
import { RequirePermission } from './guards/RequirePermission'
import { Layout } from '@shared/components/layout/Layout'
import { LogCorreoPage } from '@/features/logsCorreos/pages/LogCorreoPage'

//-Code splitting para el módulo doctores (formulario denso)
const DoctoresPage = React.lazy(() =>
  import('@/features/doctores/pages/DoctoresPage').then((m) => ({ default: m.DoctoresPage }))
)
const DoctorDetailPage = React.lazy(() => import('@/features/doctores/pages/DoctorDetailPage'))

export default function AppRoutes() {
  return (
    <AbilityProvider>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<div>Home page</div>} />
            <Route
              path="/logcorreo"
              element={
                <RequireAuth>
                  <LogCorreoPage />
                  {/*<RequirePermission action="read" subject="logcorreo">
                    
                  </RequirePermission>*/}
                </RequireAuth>
              }
            />

            {/* Mantenimiento de Doctores */}
            <Route
              path="/doctores"
              element={
                <RequireAuth>
                  <DoctoresPage />
                </RequireAuth>
              }
            />
            <Route
              path="/doctores/:cdoctor"
              element={
                <RequireAuth>
                  <DoctorDetailPage />
                </RequireAuth>
              }
            />

          </Routes>
        </Suspense>
      </Layout>
    </AbilityProvider>
  )
}
